import React from 'react'
import { Title, Summary, Experience, Education, Projects } from '../landing'
import Seo from '../components/Seo'
import '../styles/global.css'

// markup
const IndexPage = () => {
  return (
    <>
      <Seo />
      <div className="m-6">
        <div className="mx-auto max-w-3xl leading-snug text-gray-900">
          <Title />
          <br />
          <Summary />
          <br />
          <Experience />
          <br />
          <Projects />
          <br />
          <Education />
        </div>
      </div>
    </>
  )
}

export default IndexPage
